import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentWrapperComponent } from './content-wrapper.component';


@NgModule({
    declarations: [ContentWrapperComponent],
    imports: [CommonModule],
    exports: [ContentWrapperComponent],
})
export class ContentWrapperModule {}
